import { css } from '@emotion/core';

import { SPACE_COMFORTABLE, SPACE_COMPACT, flexCenter, spaceGapCompact } from '@/styles';

export const filterStyles = [
  flexCenter,
  spaceGapCompact,
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  css`
    text-align: center;
    padding: 0 ${SPACE_COMPACT}px 0 ${SPACE_COMFORTABLE}px;
    label:focus-within {
      border-color: rgba(0, 0, 0, 0); // need this placeholder to occupy space
    }
  `,
];
